[
  {
    "id": 1,
    "name": "Dakar",
    "region": "Dakar",
    "communes": [
      "Almadies",
      "Dakar Plateau",
      "Gorée",
      "Grand Dakar",
      "Gueule Tapée-Fass-Colobane",
      "Hann Bel-Air",
      "Hlm",
      "Médina",
      "Mermoz-Sacré-Cœur",
      "Ouakam",
      "Parcelles Assainies",
      "Patte d'Oie",
      "Sicap-Liberté",
      "Yoff"
    ]
  },
  {
    "id": 2,
    "name": "Guédiawaye",
    "region": "Dakar",
    "communes": [
      "Golf Sud",
      "Guédiawaye",
      "Médina Gounass",
      "Ndiarème Limamoulaye",
      "Sam Notaire"
    ]
  },
  {
    "id": 3,
    "name": "Pikine",
    "region": "Dakar",
    "communes": [
      "Dalifort",
      "Diamaguène-Sicap-Mbao",
      "Djida Thiaroye Kaw",
      "Guinaw Rail Nord",
      "Guinaw Rail Sud",
      "Mbao",
      "Niayes Thioker",
      "Pikine Est",
      "Pikine Ouest",
      "Sangalkam",
      "Thiaroye Gare",
      "Thiaroye Sur Mer",
      "Yeumbeul Nord",
      "Yeumbeul Sud"
    ]
  },
  {
    "id": 4,
    "name": "Rufisque",
    "region": "Dakar",
    "communes": [
      "Bargny",
      "Diamniadio",
      "Rufisque Est",
      "Rufisque Ouest",
      "Sébikotane",
      "Sendou"
    ]
  },
  {
    "id": 5,
    "name": "Keur Massar",
    "region": "Dakar",
    "communes": [
      "Yeumbeul Nord",
      "Yeumbeul Sud",
      "Keur Massar Nord",
      "Malika",
      "Keur Massar Sud",
      "Jaxaay-Parcelles"
    ]
  },
  {
    "id": 6,
    "name": "Thiès",
    "region": "Thiès",
    "communes": [
      "Chérif Lô",
      "Diacksao",
      "Fandène",
      "Grand Thiès",
      "Keur Ndiaye Lô",
      "Malicounda",
      "Mboro",
      "Méouane",
      "Ndiaganiao",
      "Ndiédieng",
      "Notto",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 7,
    "name": "Tivaouane",
    "region": "Thiès",
    "communes": [
      "Bambey",
      "Dangalma",
      "Darou Khoudoss",
      "Diofior",
      "Fissel",
      "Gandiaye",
      "Gossas",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Mékhé",
      "Méouane",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 8,
    "name": "Mbour",
    "region": "Thiès",
    "communes": [
      "Bargny",
      "Diamniadio",
      "Joal-Fadiouth",
      "Mbour",
      "Nguékhokh",
      "Popenguine-Ndayane",
      "Sandiarie",
      "Sébikotane",
      "Sendou",
      "Somone",
      "Thiadiaye",
      "Warang"
    ]
  },
  {
    "id": 9,
    "name": "Kaolack",
    "region": "Kaolack",
    "communes": [
      "Gandiaye",
      "Guinguinéo",
      "Kaolack",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 10,
    "name": "Nioro du Rip",
    "region": "Kaolack",
    "communes": [
      "Birkelane",
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Nioro du Rip",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Guinguinéo",
    "region": "Kaolack",
    "communes": [
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Kaffrine",
    "region": "Kaffrine",
    "communes": [
      "Birkelane",
      "Gandiaye",
      "Guinguinéo",
      "Kaffrine",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Birkilane",
    "region": "Kaffrine",
    "communes": [
      "Birkelane",
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Koungheul",
    "region": "Kaffrine",
    "communes": [
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Koungheul",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Malem Hodar",
    "region": "Kaffrine",
    "communes": [
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Malem Hodar",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Fatick",
    "region": "Fatick",
    "communes": [
      "Diofior",
      "Fimela",
      "Foundiougne",
      "Gossas",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Foundiougne",
    "region": "Fatick",
    "communes": [
      "Diofior",
      "Fimela",
      "Foundiougne",
      "Gossas",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Gossas",
    "region": "Fatick",
    "communes": [
      "Diofior",
      "Fimela",
      "Foundiougne",
      "Gossas",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Diourbel",
    "region": "Diourbel",
    "communes": [
      "Bambey",
      "Dangalma",
      "Darou Khoudoss",
      "Diourbel",
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Bambey",
    "region": "Diourbel",
    "communes": [
      "Bambey",
      "Dangalma",
      "Darou Khoudoss",
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Mbacké",
    "region": "Diourbel",
    "communes": [
      "Bambey",
      "Dangalma",
      "Darou Khoudoss",
      "Gandiaye",
      "Guinguinéo",
      "Keur Moussa",
      "Keur Samba Kane",
      "Lambaye",
      "Mbacké",
      "Médina Sabakh",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Saint-Louis",
    "region": "Saint-Louis",
    "communes": [
      "Goxu Bâb",
      "Guet Ndar",
      "Ndiarème",
      "Pikine",
      "Saint-Louis",
      "Sindoné"
    ]
  },
  {
    "id": 43,
    "name": "Dagana",
    "region": "Saint-Louis",
    "communes": [
      "Dagana",
      "Goxu Bâb",
      "Guet Ndar",
      "Ndiarème",
      "Pikine",
      "Sindoné"
    ]
  },
  {
    "id": 43,
    "name": "Podor",
    "region": "Saint-Louis",
    "communes": [
      "Dagana",
      "Goxu Bâb",
      "Guet Ndar",
      "Ndiarème",
      "Pikine",
      "Podor",
      "Sindoné"
    ]
  },
  {
    "id": 43,
    "name": "Louga",
    "region": "Louga",
    "communes": [
      "Coki",
      "Darou Marnane",
      "Keur Momar Sarr",
      "Linguère",
      "Louga",
      "Mékhé",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Kébémer",
    "region": "Louga",
    "communes": [
      "Coki",
      "Darou Marnane",
      "Kébémer",
      "Keur Momar Sarr",
      "Linguère",
      "Mékhé",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Linguère",
    "region": "Louga",
    "communes": [
      "Coki",
      "Darou Marnane",
      "Keur Momar Sarr",
      "Linguère",
      "Mékhé",
      "Ndiaganiao",
      "Ndiédieng",
      "Ndiémane",
      "Ndiob",
      "Ngalagne",
      "Ngayokhem",
      "Nguékhokh",
      "Notto",
      "Pambal",
      "Pire",
      "Pout",
      "Sébi Ponty",
      "Sindia",
      "Thiadiaye",
      "Thiénaba",
      "Touba Toul",
      "Warang"
    ]
  },
  {
    "id": 43,
    "name": "Matam",
    "region": "Matam",
    "communes": [
      "Agnam Civol",
      "Agnam-Goly",
      "Bokidiawé",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Gouraye",
      "Kanel",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Kanel",
    "region": "Matam",
    "communes": [
      "Agnam Civol",
      "Agnam-Goly",
      "Bokidiawé",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Gouraye",
      "Kanel",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Ranérou Ferlo",
    "region": "Matam",
    "communes": [
      "Agnam Civol",
      "Agnam-Goly",
      "Bokidiawé",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Gouraye",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Ziguinchor",
    "region": "Ziguinchor",
    "communes": [
      "Adéane",
      "Bignona",
      "Boutoupa-Camaracounda",
      "Djinaky",
      "Enampor",
      "Kafountine",
      "Kataba 1",
      "Kataba 2",
      "Mangagoulack",
      "Mlomp",
      "Niaguis",
      "Oulampane",
      "Sindian",
      "Tendouck",
      "Thionck Essyl",
      "Ziguinchor"
    ]
  },
  {
    "id": 43,
    "name": "Bignona",
    "region": "Ziguinchor",
    "communes": [
      "Adéane",
      "Bignona",
      "Boutoupa-Camaracounda",
      "Djinaky",
      "Enampor",
      "Kafountine",
      "Kataba 1",
      "Kataba 2",
      "Mangagoulack",
      "Mlomp",
      "Niaguis",
      "Oulampane",
      "Sindian",
      "Tendouck",
      "Thionck Essyl",
      "Ziguinchor"
    ]
  },
  {
    "id": 43,
    "name": "Oussouye",
    "region": "Ziguinchor",
    "communes": [
      "Adéane",
      "Bignona",
      "Boutoupa-Camaracounda",
      "Djinaky",
      "Enampor",
      "Kafountine",
      "Kataba 1",
      "Kataba 2",
      "Mangagoulack",
      "Mlomp",
      "Niaguis",
      "Oulampane",
      "Oussouye",
      "Sindian",
      "Tendouck",
      "Thionck Essyl",
      "Ziguinchor"
    ]
  },
  {
    "id": 43,
    "name": "Kolda",
    "region": "Kolda",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Vélingara",
    "region": "Kolda",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Médina Yoro Foulah",
    "region": "Kolda",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Sédhiou",
    "region": "Sédhiou",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Bounkiling",
    "region": "Sédhiou",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Goudomp",
    "region": "Sédhiou",
    "communes": [
      "Bounkiling",
      "Diouloulou",
      "Goudomp",
      "Kolda",
      "Médina Yoro Foulah",
      "Sédhiou",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Tambacounda",
    "region": "Tambacounda",
    "communes": [
      "Bakel",
      "Bala",
      "Bamba",
      "Barkédji",
      "Birkelane",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Goudiry",
      "Kanel",
      "Koumpentoum",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Tambacounda",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Bakel",
    "region": "Tambacounda",
    "communes": [
      "Bakel",
      "Bala",
      "Bamba",
      "Barkédji",
      "Birkelane",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Goudiry",
      "Kanel",
      "Koumpentoum",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Tambacounda",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Goudiry",
    "region": "Tambacounda",
    "communes": [
      "Bakel",
      "Bala",
      "Bamba",
      "Barkédji",
      "Birkelane",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Goudiry",
      "Kanel",
      "Koumpentoum",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Tambacounda",
      "Thilogne",
      "Vélingara"
    ]
  },
  {
    "id": 43,
    "name": "Koumpentoum",
    "region": "Tambacounda",
    "communes": [
      "Bakel",
      "Bala",
      "Bamba",
      "Barkédji",
      "Birkelane",
      "Dabia",
      "Diawara",
      "Gamadji Saré",
      "Goudiry",
      "Kanel",
      "Koumpentoum",
      "Matam",
      "Naboun",
      "Ogo",
      "Orkadiéré",
      "Ourossogui",
      "Pété",
      "Podor",
      "Ranérou",
      "Sagatta",
      "Sinthiou Bamambé",
      "Tambacounda",
      "Thilogne",
      "Vélingara"
    ]
  }
]
